// src/app/services/profile.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProfileDetails } from '../Models/profile.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private apiUrl = '/TgNewUI/CandidateZone/Ajax/ViewEditProfile';

  constructor(private http: HttpClient) {}

  fetchProfileDetails(payload: any): Observable<ProfileDetails> {
    return this.http.post<ProfileDetails>(this.apiUrl, payload);
  }
}